import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { enqueueSnackbar } from 'notistack'

import Modal from '../../common/modal/Modal';
import Button from '../../common/button/Button';
import './StylesDeactivateBlogModal.scss';
import { deactivateBlog } from '../../../api/blogs';

const DeactivateBlogModal = ({ handleClose, blogId, refetch }) => {
  const {
    isLoading,
    isError,
    isSuccess,
    mutate
  } = useMutation(() => deactivateBlog({blogId}));

  const handleDeactivate = () => mutate();

  useEffect(() => {
    if (!isError && !isLoading && isSuccess) {
      enqueueSnackbar('Blog deactivated', { variant: 'success' });
      refetch();
      handleClose();
    }

    if(!isLoading && isError) {
      enqueueSnackbar('Issues with blog deactivation', { variant: 'error' });
      handleClose();
    }
  }, [isLoading, isError, handleClose, isSuccess, refetch])

  return (
    <Modal
      title='Deactivate Blog'
      onClose={handleClose}
    >
      <div className='DeactivateBlogModal'>
        <span>
          Please confirm that you would like to mark this blog as deactivated.
        </span>
        <Button
          isModal
          isLoading={isLoading}
          onClick={handleDeactivate}
        >
          Confirm
        </Button>
      </div>
    </Modal>
  )
}

export default DeactivateBlogModal;